/**
 * Returns a suffix-appending function that is pre-initialised with a namespace string.
 */
export const setNamespace = (namespace = '') => {
  if (!namespace) {
    console.warn('namespacify() must be initialised with a namespace before use!');
  }

  const appendSuffix = (suffix = '') => `${ namespace }${ suffix }`;
  const isValidSuffix = (suffix = '') => typeof suffix === 'string';

  /**
  * Appends zero or more suffixes to the pre-initialised namespace.
  * Defaults to returning the unmodified namespace.
  * @see {@link setNamespace} for namespace initilisation.
  */
  const namespacify = (implicitSuffix, ...additionalSuffixes) => {
    // If we're calling this function, we always want at least one namespace returned.
    // `implicitSuffix` covers this requirement, ensuring `toNamespace` runs even if no args are provided.
    // Any non-string suffixes (e.g. as a result of conditional classes being rejected) will be ignored.
    return [ implicitSuffix, ...additionalSuffixes ]
      .filter(isValidSuffix)
      .map(appendSuffix)
      .join(' ');
  };

  return namespacify;
};
